<form id="container" class="m-4">
  <h5><span class="fa-light fa-triangle-exclamation text-danger mr-2" ></span><strong>{{ "MANUAL_DOOR_ID_OVERRIDE" | translate }}</strong></h5>
  <p>{{ "MANUAL_DOOR_ID_OVERRIDE_WARNING" | translate }}</p>

  <button type="button" class="btn btn-primary" (click)="confirm()">
    {{ "CONFIRM" | translate }}
  </button>

  <button type="button" class="btn secondaryBtnWhiteBg ml-2" (click)="cancel()">
    {{ "CANCEL" | translate }}
  </button>
</form>
